import { useEmployeeStore } from './EmployeeStore'
import { useLocationStore } from './LocationStore'
import { useTaskStore } from './TaskStore'
import { useTimesheetStore } from './TimesheetStore'
import { useAbsenceStore } from './AbsenceStore'
import { useCorrectionStore } from './CorrectionStore'
import { useChecklistStore } from './ChecklistStore'
import { useProjectStore } from './ProjectStore'
import { useEventStore } from './EventStore'
import { useConfigStore } from './ConfigStore'
import { useServerQueue } from './ServerQueue'
import type { Employee } from '@/classes/Employee'
import { useSurveyStore } from './SurveyStore'
import { useAuthStore } from './AuthStore'
import { useAmplitudeStore } from './AmplitudeStore'
import { useNoteStore } from './NoteStore'
import { useShiftStore } from './ShiftStore'
import { useClockReminderStore } from './ClockReminderStore'

export const deviceStoreDefinitions = [
  useServerQueue,
  useConfigStore,
  useEventStore,
  useTaskStore,
  useEmployeeStore,
  useLocationStore,
  useChecklistStore,
  useProjectStore,
  useAmplitudeStore,
  useNoteStore,
]

export const userStoreDefinitions = [
  useTimesheetStore,
  useAbsenceStore,
  useCorrectionStore,
  useSurveyStore,
  useShiftStore,
  useClockReminderStore,
]

export const getDeviceStores = () => deviceStoreDefinitions.map((s) => s())

export const getUserStores = () => userStoreDefinitions.map((s) => s())

export const getUserStoresToSync = (emp: Employee) => {
  // wenn sich was an der Store-Logik verändert,
  // müssen nur diese Condition-Store-Paare angefasst werden
  const conditionsAndStores = [
    { condition: emp.can_request_absences, store: useAbsenceStore },
    {
      condition: emp.can_show_times || emp.can_request_absences,
      store: useTimesheetStore,
    },
    { condition: emp.can_show_times, store: useCorrectionStore },
    { condition: useAuthStore().isPersonalDevice, store: useSurveyStore },
    { condition: useConfigStore().shift_plans_enabled, store: useShiftStore },
  ]

  return conditionsAndStores
    .filter((item) => item.condition)
    .map((item) => item.store())
}
